import {Component, Input, OnInit} from '@angular/core';
import {DatepickerService} from '@app/shared/services/datepicker.service';
import {HtmlHelper} from '@app/shared/helpers';

@Component({
  selector: 'app-datepicker',
  templateUrl: './datepicker.component.html',
  styleUrls: ['./datepicker.component.scss']
})

export class DatepickerComponent implements OnInit {
  @Input() isHeaderDatepicker: boolean;
  changeWeeksBarStatus = false;
  isMobile: boolean;
  windowWidth: number = window.innerWidth;

  constructor(
    private datepickerService: DatepickerService,
  ) { }

  ngOnInit(): void {
    this.isMobile = HtmlHelper.checkMobile(this.windowWidth);
  }

}



// WEBPACK FOOTER //
// ./src/app/datepicker/datepicker.component.ts